<template>
  <div class="landing-box">
    {{ msg }}
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { getToken, h5Check } from '@/common/apiGeneral.js';
import { getTaskDetail, updateOrderTag } from '@/common/apiPaic.js';
import { cookieSet } from '@/common/cookie';
import {
  ORDER_STATUS_CODE,
  TASK_STATUS_CODE,
  generalProductCode
} from '@/common/constant';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      tokenKey: '',
      taskNo: '',
      orderNo: null,
      orderStatus: null,
      taskStatus: null,
      msg: '正在处理订单信息...',
      categoryParentCode: ''
    };
  },
  mounted() {
    const { tokenKey, taskNo } = this.$route.params;
    if (tokenKey && taskNo) {
      this.tokenKey = tokenKey;
      this.taskNo = taskNo;
      this.getToken();
    }
  },
  methods: {
    ...mapActions('orderGeneral', ['setOrderStatus', 'setTaskStatus']),
    toPage() {
      let name = 'GeneralOrderDetail';
      // 根据类型去往的页面
      if (
        [generalProductCode.categoryCode_FL90000001].includes(this.categoryParentCode)
      ) {
        // 根据订单状态去往的页面
        if (
          [
            ORDER_STATUS_CODE.auditReturn,
            ORDER_STATUS_CODE.settlementReturn,
            ORDER_STATUS_CODE.processing
          ].includes(this.orderStatus)
        ) {
          // 事故救援
          name = 'GeneralOrderAccidentRescue';
        }
      } else {
        // 根据任务状态判断去往的页面
        if (
          [ORDER_STATUS_CODE.auditReturn, ORDER_STATUS_CODE.settlementReturn].includes(
            this.orderStatus
          )
        ) {
          // 初审退回和结算退回页面
          name = 'GeneralOrderReAudit';
        } else if ([ORDER_STATUS_CODE.processing].includes(this.orderStatus)) {
          switch (this.taskStatus) {
            // 待服务
            case TASK_STATUS_CODE.take:
              name = 'GeneralOrderWaitService';
              break;
            // 待到达现场
            case TASK_STATUS_CODE.start:
              name = 'GeneralOrderWaitArrive';
              break;
            // 已到达
            case TASK_STATUS_CODE.arrive:
              name = 'GeneralOrderTaskExecution';
              break;
            // 开始拖车
            case TASK_STATUS_CODE.workStart:
              name = 'GeneralOrderTrailing';
              break;
            // 拖车结束
            case TASK_STATUS_CODE.workEnd:
              name = 'GeneralOrderTrailCompleted';
              break;
            // 任务完成
            case TASK_STATUS_CODE.finish:
              // name = 'GeneralOrderExecuted';
              // 进入订单详情
              name = 'GeneralOrderDetail';
              break;

            default:
              name = 'GeneralOrderDetail';
              break;
          }
        }
      }
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      console.log('this.taskStatus: ', this.taskStatus);
      console.log('router: ', router);

      this.$router.replace(router);
    },
    async getToken(noLoading) {
      this.msg = '正在获取token...';
      if (!this.tokenKey) {
        this.msg = '缺失tokenKey';
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getToken({
          key: this.tokenKey
        });
        if (!noLoading) {
          this.$toast.clear();
        }
        if (data) {
          cookieSet('token', data.token);
          this.h5Check();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async h5Check(noLoading) {
      this.msg = '正在处理订单信息...';
      if (!this.taskNo) {
        this.msg = '缺失taskNo';
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await h5Check({
          taskNo: this.taskNo
        });
        if (!noLoading) {
          this.$toast.clear();
        }
        this.getTaskDetail();
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        console.log('dd');
        const data = await getTaskDetail({
          taskNo: this.taskNo
        });
        if (data) {
          const {
            orderNo,
            orderStatus,
            taskStatus,
            categoryParentCode,
            papUpPaic,
            categoryCode,
            isPaicOrder
          } = data;
          this.orderNo = orderNo;
          this.orderStatus = orderStatus;
          this.taskStatus = taskStatus;
          this.categoryParentCode = categoryParentCode;
          this.setOrderStatus(orderStatus);
          this.setTaskStatus(taskStatus);
          // 平安订单 拖车、搭电、困境，没弹过框的需要弹框
          if (
            isPaicOrder &&
            [
              generalProductCode.categoryCode_FL10000002,
              generalProductCode.categoryCode_FLA0000002,
              generalProductCode.categoryCode_FL10000006
            ].includes(categoryCode) &&
            !papUpPaic
          ) {
            // 搭电 ---> 是否有马甲、检测仪？
            // 拖车、困境 --->是否有马甲？
            const msg =
              categoryCode === generalProductCode.categoryCode_FL10000006
                ? '是否有马甲、检测仪？'
                : '是否有马甲？';
            Dialog.confirm({
              title: '提示',
              message: msg,
              confirmButtonText: '是',
              cancelButtonText: '否'
            })
              .then(() => {
                this.updateOrderTag([]);
              })
              .catch(() => {
                this.updateOrderTag(['FOR_FOREIGN_AID']);
              });
          } else {
            this.toPage();
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrderTag(orderTag) {
      try {
        const data = await updateOrderTag({
          taskNo: this.taskNo,
          taskStatus: this.taskStatus,
          orderTag: orderTag
        });
        console.log('data', data);
        this.toPage();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.landing-box {
  margin-top: 100px;

  text-align: center;

  font-size: 16px;
}
</style>
